import {
    PlaylistState,
    PlaylistActionTypes,
  } from './types'

export const initialState: PlaylistState = {
    videos: []
}

export default (state:PlaylistState = initialState, action: PlaylistActionTypes) : PlaylistState => {

    switch (action.type) {
        case '@@playlist/ADD_VIDEO':
            state.videos.push(action.payload.entry)
            return state
        case '@@playlist/REMOVE_VIDEO':
            state.videos = state.videos.filter(entry => entry.file.name !== action.payload.name) 
            return state
        case '@@playlist/REMOVE_ALL':
            state.videos = []
            return state
        default:
            return state
    }
}
    